import { CompanyEntity } from '../types/CompanyEntity'
import ApiBase from './Api'

type UpdateCompanyBody = {
    countryCode: string | null
    registrationNumber: string | null
}

const COMPANY_API_PATHS = {
    ALL_COMPANIES: '/companies',
    COMPANY_BY_ID: (companyId: string) => `/companies/${companyId}`,
    COMPANY_ADMIN: (companyId: string) => `/admin/companies/${companyId}`,
}

class CompanyApi extends ApiBase {
    async findAll(): Promise<CompanyEntity[]> {
        const response = await this._getRequest(COMPANY_API_PATHS.ALL_COMPANIES)

        return response
    }
    async findByCompanyId(companyId: string | null): Promise<CompanyEntity | null> {
        if (!companyId) {
            return null
        }
        const company: CompanyEntity = await this._getRequest(COMPANY_API_PATHS.COMPANY_BY_ID(companyId))

        if (company?.shares) {
            company.shares = company.shares.sort((shareA, shareB) => {
                // Sort by normal shares first, then by delisted date, then by millistream shares
                if (!!shareA.isPref === !!shareB.isPref) {
                    if (shareA.delistedDate === shareB.delistedDate) {
                        return shareB.millistreamShares ?? 0 - (shareA.millistreamShares ?? 0)
                    }
                    const dateA = shareA.delistedDate ? new Date(shareA.delistedDate) : new Date()
                    const dateB = shareB.delistedDate ? new Date(shareB.delistedDate) : new Date()
                    return dateB.getTime() - dateA.getTime()
                }
                return shareA.isPref ?? 0 - (shareB.isPref ?? 0)
            })
        }

        return company
    }
    async updateCompany(companyId: string | null, data: UpdateCompanyBody): Promise<CompanyEntity | null> {
        if (!companyId) {
            return null
        }
        const response = (await this._putRequest(
            COMPANY_API_PATHS.COMPANY_ADMIN(companyId),
            data,
        )) as CompanyEntity | null

        return response
    }
}

export default CompanyApi
